module.exports = __webpack_public_path__ + "static/media/bg-top.b3c3cdc0.png";